import UserTypeSwitcher from "../../../components/Dashboards/admin"
import { useAppSelector } from "../../../store/hooks";
import { selectAuthSlice } from "../../../store/authSlice";
import { IUser } from "../../../utils/interfaces";

function AdminIndexPage() {
  const userInfo = useAppSelector(selectAuthSlice);
  return (
    <UserTypeSwitcher userInfo={userInfo.user as IUser} company_id={userInfo.user?.company.id as string } />
  )
}

export default AdminIndexPage;